export var AttachmentTypeEnum;
(function (AttachmentTypeEnum) {
    AttachmentTypeEnum["APPROVAL"] = "APPROVAL";
    AttachmentTypeEnum["CERTIFIED_ID"] = "CERTIFIED_ID";
    AttachmentTypeEnum["CONTRACT"] = "CONTRACT";
    AttachmentTypeEnum["CORRECTION_NOTE"] = "CORRECTION_NOTE";
    AttachmentTypeEnum["COUNTERSIGNED_CONTRACT"] = "COUNTERSIGNED_CONTRACT";
    AttachmentTypeEnum["ID_DOCUMENT"] = "ID_DOCUMENT";
    AttachmentTypeEnum["LICENSE"] = "LICENSE";
    AttachmentTypeEnum["PROOF_OF_ADDRESS"] = "PROOF_OF_ADDRESS";
    AttachmentTypeEnum["SPECIAL_AGREEMENT"] = "SPECIAL_AGREEMENT";
    AttachmentTypeEnum["SUPPORTING_DOCUMENT"] = "SUPPORTING_DOCUMENT";
    AttachmentTypeEnum["TAX_OFFICE_REGISTRATION"] = "TAX_OFFICE_REGISTRATION";
})(AttachmentTypeEnum || (AttachmentTypeEnum = {}));
export const AttachmentType = {
    APPROVAL: AttachmentTypeEnum.APPROVAL,
    CERTIFIED_ID: AttachmentTypeEnum.CERTIFIED_ID,
    CONTRACT: AttachmentTypeEnum.CONTRACT,
    CORRECTION_NOTE: AttachmentTypeEnum.CORRECTION_NOTE,
    COUNTERSIGNED_CONTRACT: AttachmentTypeEnum.COUNTERSIGNED_CONTRACT,
    ID_DOCUMENT: AttachmentTypeEnum.ID_DOCUMENT,
    LICENSE: AttachmentTypeEnum.LICENSE,
    PROOF_OF_ADDRESS: AttachmentTypeEnum.PROOF_OF_ADDRESS,
    SPECIAL_AGREEMENT: AttachmentTypeEnum.SPECIAL_AGREEMENT,
    SUPPORTING_DOCUMENT: AttachmentTypeEnum.SUPPORTING_DOCUMENT,
    TAX_OFFICE_REGISTRATION: AttachmentTypeEnum.TAX_OFFICE_REGISTRATION,
};
